import * as React from "react";
import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 512 357" {...props}>
    <path d="M16 133.6h260.5c7.2 29 33.5 50.6 64.7 50.6s57.5-21.6 64.7-50.6H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-90.1c-7.2-29-33.4-50.6-64.7-50.6s-57.5 21.6-64.7 50.6H16c-8.8 0-16 7.2-16 16s7.2 16 16 16zM341.2 83c19.1 0 34.6 15.5 34.6 34.6s-15.5 34.6-34.6 34.6-34.6-15.5-34.6-34.6S322.1 83 341.2 83zM16 272h90.1c7.2 29 33.4 50.6 64.7 50.6s57.5-21.6 64.7-50.6H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H235.5c-7.2-29-33.4-50.6-64.7-50.6S113.3 211 106.1 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16zm154.8-50.6c19.1 0 34.6 15.5 34.6 34.6s-15.5 34.6-34.6 34.6-34.6-15.5-34.6-34.6 15.5-34.6 34.6-34.6z" />
  </svg>
);

export default SvgComponent;
